import { useTranslation } from 'react-i18next';
import { useLengthValidationRule, useArrayLengthValidationRule } from 'src/shared/hooks/formValidations';

export const useSeoValidationRules = () => {
  const { t } = useTranslation(['validations']);

  const titleLength = useLengthValidationRule({ t, max: 60 });
  const descriptionLength = useLengthValidationRule({ t, max: 160 });
  const keyWordsLength = useArrayLengthValidationRule({ t, max: 20 });
  const textLength = useLengthValidationRule({ t, max: 10000 });

  return {
    seo_title: [titleLength],
    seo_description: [descriptionLength],
    seo_keywords: [keyWordsLength],
    seo_text: [textLength],
  };
};
